import { useDeferredValue, useMemo, useState } from 'react';
import { filterGoogleLocations, googleLocationKey, indexGoogleLocations } from './filter';

const NO_SELECTION = [];

export const useGoogleLocationsFilter = (locations, { withConnectedFilter = true, selected = NO_SELECTION } = {}) => {
    const [query, setQuery] = useState('');
    const [hideConnected, setHideConnected] = useState(true);
    const [hideUnverified, setHideUnverified] = useState(false);
    const deferredQuery = useDeferredValue(query);

    const index = useMemo(() => indexGoogleLocations(locations), [locations]);
    const selectedKeys = useMemo(() => new Set(selected.map(googleLocationKey)), [selected]);

    const hasConnected = withConnectedFilter && locations.some(l => l.connected);
    const hidesConnected = hasConnected && hideConnected;
    const hasUnverified = locations.some(l => !l.isVerified && !(hidesConnected && l.connected));
    const hidesUnverified = hasUnverified && hideUnverified;

    const { matching, visible } = useMemo(
        () =>
            filterGoogleLocations(index, {
                query: deferredQuery,
                hideConnected: hidesConnected,
                hideUnverified: hidesUnverified,
                selectedKeys,
            }),
        [index, deferredQuery, hidesConnected, hidesUnverified, selectedKeys],
    );

    return {
        query,
        setQuery,
        hideConnected,
        setHideConnected,
        hideUnverified,
        setHideUnverified,
        hasConnected,
        hasUnverified,
        hasLocations: locations.length > 0,
        allConnectedHidden: hidesConnected && locations.every(l => l.connected),
        matchingLocations: matching,
        visibleLocations: visible,
    };
};
